import * as Styled from './ImpactImage.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The Image Used in the Impact Block.
 *
 * @prop imagePosition the position of the Image relative to the form when the impact
 * block is in a 1-Section Layout. This prop does nothing when the Block is not in a 1-Section Layout.
 */
export const ImpactImage = ({
  cssImageOpacity,
  imagePosition,
  parentLayoutInfo,
  ...nextImgProps
}) => /*#__PURE__*/_jsx(Styled.ImpactImageContainer, {
  cssImageOpacity: cssImageOpacity,
  imagePosition: imagePosition,
  parentLayoutInfo: parentLayoutInfo,
  children: /*#__PURE__*/_jsx(Styled.Image, {
    ...nextImgProps
  })
});